export const FormDivider = () => (
  <div className="my-8">
    <div className="bg-overlay-dark h-[1px] w-full" />
  </div>
);
